<template>
  <div class="price">
    <h2>El premio</h2>
    <img
      class="price__price"
      src="@/assets/images/price/premio.png"
      alt="DiDi Shark Tank"
    />
    <p>
      El emprendimiento ganador de DiDi Lab se llevará a casa
      <span
        >50 millones de pesos para potencializar su negocio,  asimismo, contará con una consultoría por parte de expertos del Centro de Emprendimiento de la Facultad de Administración de la Universidad de los Andes,</span
      >
      quienes orientarán al ganador en cómo llevar su negocio al siguiente
      nivel.
    </p>

    <h4>ALIADOS</h4>

    <img
      src="@/assets/images/logo_andes.png"
      alt="DiDi Shark Tank"
      class="andes"
    />

    <p class="text--2">
      A través del Centro de Emprendimiento de la Facultad de Administración, la Universidad de los Andes se une a DiDi Lab para aportar con su conocimiento y experiencia académica en la búsqueda de los emprendimientos con mayor impacto para la reactivación del país. <br />
      <br />

      La universidad realizará el diseño de las pruebas, los criterios de evaluación de los emprendimientos y seleccionará a los participantes que harán su pitch frente a los jurados, de acuerdo con el desempeño en las pruebas.
    </p>

    <img
      src="@/assets/images/logo_sony.png"
      alt="DiDi Shark Tank"
      class="sony"
    />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.price {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url("../assets/images/price/bg.jpg") no-repeat;
  background-size: cover;

  h2 {
    color: white;
    text-transform: uppercase;
    font-size: 2rem;

    @include phone {
      margin-top: 2rem;
    }
  }
  p {
    width: 60%;
    color: white;
    text-align: center;

    @include phone {
      width: 90%;
    }

    span {
      color: $main-color;
    }
  }

  .text {
    margin: 6rem 0 2rem 0;
    color: $main-color;
  }

  &__price {
    width: 50%;
    margin: 4rem 0;

    @include phone {
      width: 90%;
    }
  }

  h4 {
    margin: 6rem 0 4rem 0;
    color: white;
    font-size: 1.5rem;
  }

  .andes {
    width: 200px;
    margin-bottom: 4rem;
  }

  .text--2 {
    width: 50%;
    color: white;
    font-family: "Montserrat", sans-serif;
    font-weight: 600;

    @include phone {
      width: 90%;
    }
  }

  .sony {
    width: 140px;
    margin: 6rem 0;
  }
}
</style>